import React, {useState} from "react";
import {useMutation} from "@apollo/react-hooks";
import {IModalProps} from "../../../../libs/uiKit/modal/types";
import useNotification from "../../../widgets/notifier/ui/hooks/useNitification";
import {SEND_DECLARATION_TEXT} from "../../../../libs/api/commands";
import Button from "../../../../libs/uiKit/button";
import {useForm} from "react-hook-form";
import {NewModal} from "../../../../libs/uiKit/modal/NewModal";
import {StyledDeclarationText} from "./styles";
import Input from "../../../../libs/uiKit/input";
import {SendDeclarationTextMutation, SendDeclarationTextMutationVariables} from "../../../../libs/api/graphqlTypes";
import {BASE_API_URL} from "../../../../libs/utils/staticData";

type IDeclarationTextModalProps = {
    life: boolean;
    property: boolean;
} & IModalProps;

const DeclarationTextModal = (props: IDeclarationTextModalProps) => {

  const { life, property } = props;

  const formHook = useForm({mode: "onBlur"});

  const {setNotification} = useNotification();

  const [stateEmail , setStateEmail] = useState("");

  const [sendDeclaration, {loading: loadingSendDeclaration}] = useMutation<SendDeclarationTextMutation, SendDeclarationTextMutationVariables>(SEND_DECLARATION_TEXT);

  const stringIsEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const sendDeclarationToEmail = () => {
    if(!stateEmail) {
      setNotification({type: "error", text: "Введите корректный email"});
      return;
    }
    const type = life && property ? 'lp' : life ? 'l' : 'p';
    sendDeclaration({
      variables: {
        email: stateEmail,
        type,
      }
    }).then(({ data }) => {
      setNotification({type:"success", text: `Декларация отправлена на адрес ${stateEmail}`});
    }).catch(error => setNotification({ type: 'error', text: error }))
  }

  const printDeclaration = () => {
    const type = life && property ? 'lp' : life ? 'l' : 'p';
    window.open(`${BASE_API_URL}/get-file/declaration?type=${type}`, '_blank');
  }



  return (
    <NewModal {...props} header="Декларация" isLoading={false}>
      <form>
        <StyledDeclarationText>

            <p>Я заверяю о нижеследующем:</p>

            <p>На момент предоставления мной согласия с настоящей декларацией:</p>

            {property && <ul>
                <li>Объект страхования расположен в многоквартирном доме, построенном после 1960 года и имеет более 3х наземных этажей;</li>
                <li>Конструктивные элементы многоквартирного дома (стены и перекрытия), в котором расположен объект страхования, не являются горючими (деревянными);</li>
                <li>Многоквартирный дом, в котором расположен объект страхования, не признан аварийным, подлежащим отселению, не находится в зоне стихийного бедствия;</li>
                <li>В объекте страхования отсутствуют камины/печи, сауны/ бани;</li>
                <li>В объекте страхования отсутствует перепланировка и/или переоборудование или проведена перепланировка и/или переоборудование без соответствующего разрешения, но несущие конструкции жилого дома не затронуты: не сносили полностью или частично, не вырубали/ увеличивали проемы дверей/окон, не оборудовали ниши.</li>
            </ul>}

            {life && property && <p>А также заверяю, что:</p>}

            {life &&
                <ul>
                    <li>я не занимаюсь профессионально или на регулярной любительской основе опасными
                        видами спорта (авто- и мотоспорт, прыжки с парашютом, контактные единоборства,
                        альпинизм, горный и водный туризм, подводное плавание и т.п.);
                    </li>
                    <li>моя профессия не связана с повышенным риском (например, пребыванием на высоте,
                        под водой, под землей, на нефтяных и газовых платформах, с облучением, работа с
                        химическими и взрывчатыми веществами, испытаниями, инкассация, работа в
                        правоохранительных органах и т. п.);
                    </li>
                    <li>я не состою на службе в вооруженных силах РФ;
                    </li>
                    <li>я не нахожусь под следствием (не являюсь обвиняемым, подозреваемым,
                        подсудимым) и в местах лишения свободы;
                    </li>
                    <li>подтверждаю, что мой возраст находится в диапазоне: от 18 лет на момент начала
                        периода страхования до 65 лет на момент окончания периода страхования
                        (включительно);
                    </li>
                    <li>не являюсь инвалидом I, II, III группы и не имею действующего направления и не
                        прохожу медико-социальную экспертизу, никогда не получал какие-либо пособия по
                        инвалидности, никогда не подавал заявления на такие пособия;
                    </li>
                    <li>в течение двух лет, предшествующих текущей дате, не имел непрерывной
                        нетрудоспособности сроком более 30 дней;
                    </li>
                    <li>моя трудоспособность не является ограниченной в связи с нарушением здоровья,
                        обусловленным травмой, отравлением или болезнью;
                    </li>
                    <li>не страдаю нервными или психическими расстройствами (включая эпилепсию,
                        рассеянный склероз, болезнь Паркинсона, миастению), не состою на диспансерном
                        учете по этому поводу; не страдаю алкоголизмом, наркоманией, токсикоманией, не
                        принимаю наркотики, не выкуриваю более 20 сигарет в день и не выпиваю более 0,5
                        литров крепкого алкоголя в неделю;
                    </li>
                    <li>не страдаю хроническими заболеваниями печени (хронические гепатиты вирусной и
                        невирусной природы, цирроз печени любой этиологии и т. д.), неспецифическим
                        язвенным колитом, болезнью Крона и ЖКТ в терминальной стадии, хроническим
                        панкреатитом с ежегодным обострением, язвой желудка и/или двенадцатиперстной
                        кишки (с последним обострением менее трех лет от даты подачи заявления на
                        страхование), калькулезным холециститом (наличие камней в желчном пузыре);
                    </li>
                    <li>никогда не получал рекомендаций по снижению веса, не страдаю ожирением и
                        избыточной массой тела;
                    </li>
                    <li>не имею доброкачественных новообразований органов и тканей, у меня нет и не было
                        онкологических заболеваний;
                    </li>
                    <li>не страдаю хроническим пиелонефритом, гломерулонефритом, почечной
                        недостаточностью, не имею других патологий в области почек: единственная почка,
                        нефроптоз, гидронефроз и т. д.;
                    </li>
                    <li>не переносил инсульты (острое нарушение мозгового кровообращения), инфаркты,
                        тромбоэмболию легочной артерии, операции на сердце и сосудах сердца
                        (стентирование, шунтирование); не страдаю хроническими заболеваниями сердечнососудистой системы
                        стенокардией, ишемической болезнью сердца, гипертонией II-III
                        степени, ревмокардитом, атеросклерозом, синдромом WPW, не имею пороков сердца
                        и аневризмы сердца;
                    </li>
                    <li>не страдаю заболеваниями органов кроветворения и кровеносной системы, в том
                        числе: анемией средней и тяжелой степени тяжести, гемофилией, лейкемией;
                    </li>
                    <li>не страдаю заболеваниями дыхательной системы: эмфиземой, бронхиальной астмой
                        либо хронической обструктивной болезнью лёгких, туберкулезом (на момент начала
                        страхования не нахожусь на лечении и не состою на учете в противотуберкулезном
                        диспансере), пневмокониозом;
                    </li>
                    <li>не страдаю заболеваниями и расстройствами опорно-двигательного аппарата:
                        коксартроз, остеомиелит, подагра, паралич, деформирующий артроз;
                    </li>
                    <li>не страдаю сахарным диабетом;
                    </li>
                    <li>не страдаю заболеванием глаз и расстройством зрения (глаукома, миопия высокой
                        степени -8 дптр. и выше);
                    </li>
                    <li>не страдаю системными аутоиммунными заболеваниями (системная красная
                        волчанка, склеродермия, дерматомиозит, саркоидоз, ревматоидный артроз и т. д.);
                    </li>
                    <li>не нахожусь на стационарном лечении и не нуждаюсь в уходе по состоянию здоровья;
                    </li>
                    <li>не обращался за оказанием медицинской помощи по поводу СПИДа, не являюсь
                        носителем ВИХ и не болен СПИДом;
                    </li>
                    <li>мне неизвестно о наличии у меня заболеваний и последствий травм, которые могли
                        бы потребовать оперативного лечения (кроме стоматологического лечения);
                    </li>
                    <li>не употребляю и мне не назначены никакие медикаменты, в том числе сердечные
                        препараты, препараты для коррекции артериального давления, антидепрессанты,
                        наркотические, гормональные, болеутоляющие вещества;
                    </li>
                    <li>(для женщин) в настоящий момент не беременна, отсутствуют установленные
                        заболевания женских органов: яичников с придатками, маточных труб, матки,
                        наружных и внутренних половых органов, а также протоков бартолиновых желез;
                    </li>
                    <li>(для мужчин) отсутствуют установленные заболевания органов репродуктивной
                        системы: яичек, предстательной железы, уретры и мочевого пузыря, наружных
                        половых органов.
                    </li>
                </ul>
            }
        </StyledDeclarationText>
          <Button appearance="filled" style={{marginTop: "2rem"}} onClick={printDeclaration}>
              Распечатать
          </Button>
          <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "2rem", marginTop: "2rem"}}>
              <Input placeholder="Электронная почта" style={{height: "44px"}} onChange={(e) => setStateEmail(e.target.value)} value={stateEmail} />
              <Button appearance="filled" style={{marginTop: "0"}} isDisabled={!stateEmail || !stringIsEmail(stateEmail)} isLoading={loadingSendDeclaration} onClick={sendDeclarationToEmail}>
                  Отправить
              </Button>
          </div>
      </form>
    </NewModal>
  );
}

export default DeclarationTextModal;